import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { addAgent } from "../../services/agent.service";

export default function AgentAdd() {
  const { token } = useSelector((state) => state?.auth);
  const [isLoading2, setIsLoading2] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      email: item.agentEmail,
      mobile_number: item.agentContact,
      password: null,
      fullname: item.agentName,
      agent_address: item.agentAddress,
      user_code: item.agentCode,
      role: "Agent",
    };

    try {
      const res = await addAgent(token, data);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Added!",
          text: `${item.agentName} Agent has been added.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/agent");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        const emailError = res?.data?.email ? `${res?.data?.email}<br>` : "";
        const mobileError = res?.data?.mobile_number
          ? `${res?.data?.mobile_number}`
          : "";
        Swal.fire("Error", `${emailError}${mobileError}`, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding agent:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Agent</h4>
                <Link to="/agent">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Agent Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent name"
                          maxLength={30}
                          {...register("agentName", {
                            required: "Name is required",
                          })}
                        />
                        {errors.agentName && (
                          <p className="error">{errors.agentName.message}</p>
                        )}
                      </div>

                      {/* Agent Code */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Code</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent code"
                          maxLength={10}
                          {...register("agentCode", {
                            required: "Code is required",
                          })}
                        />
                        {errors.agentCode && (
                          <p className="error">{errors.agentCode.message}</p>
                        )}
                      </div>

                      {/* Agent Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent email"
                          maxLength={50}
                          {...register("agentEmail", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors.agentEmail && (
                          <p className="error">{errors.agentEmail.message}</p>
                        )}
                      </div>

                      {/* Agent Contact */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter contact number"
                          maxLength={10}
                          {...register("agentContact", {
                            required: "Contact number is required",
                            pattern: {
                              value: /^[1-9][0-9]{9}$/,
                              message:
                                "Contact number must be 10 digits and not start with 0",
                            },
                          })}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ))
                          }
                        />
                        {errors.agentContact && (
                          <p className="error">{errors.agentContact.message}</p>
                        )}
                      </div>

                      {/* Agent Address */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">Agent Address</label>
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter agent address"
                          maxLength={200}
                          {...register("agentAddress")}
                        />
                        {errors.agentAddress && (
                          <p className="error">{errors.agentAddress.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          ADD AGENT
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          ADDING AGENT
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
